module.exports = __webpack_public_path__ + "img/car-what-is.5d5f79f.png";